var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{staticStyle:{"width":"100%","height":"200px"},attrs:{"id":"tvideo","playsinline":"","webkit-playsinline":""}})])
}]

export { render, staticRenderFns }